export default "__VITE_ASSET__CfT7FLXY__"